import { useState } from 'react'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import useModalClose from 'hooks/useModalClose'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { IKitchenDish } from 'types/kitchen/kitchenDish.interface'
import { IKitchenIngredient } from 'types/kitchen/kitchenIngredient.interface'
import { Badge } from 'components/Badge/Badge'
import { KITCHEN_STATUS_COLORS } from '../kitchenData'
import { KitchenTag } from '../Kitchen.styled'

interface IProps {
  dish: IKitchenDish
  ingredients: IKitchenIngredient[]
  closeModal: () => void
  onSave: (dish: IKitchenDish) => void
}

export const RecipeModal = ({ dish: initialDish, ingredients, closeModal, onSave }: IProps) => {
  const [dish, setDish] = useState(initialDish)
  useModalClose(closeModal)

  const ing = (id: number) => ingredients.find((i) => i.id === id)

  const totalCost = dish.norm.reduce((s, l) => {
    const i = ing(l.ing)
    if (!i) return s
    return s + (l.qty / i.factor) * i.price
  }, 0)

  return (
    <Modal black width='600px'>
      <Flex column gap='1rem' width='100%'>
        <Flex between width='100%' center>
          <TitleText weight='bold'>Recipe — {dish.name}</TitleText>
          <CursorPointer onClick={closeModal}>
            <CloseIcon />
          </CursorPointer>
        </Flex>
        <Flex gap='0.25rem' wrap>
          {dish.tags.map((t) => (
            <KitchenTag key={t}>{t}</KitchenTag>
          ))}
          <Badge hexColor={KITCHEN_STATUS_COLORS.Prepared}>
            <BodyText>Prepared</BodyText>
          </Badge>
        </Flex>
        <Flex column gap='0.5rem' width='100%'>
          {dish.norm.map((l, i) => {
            const ii = ing(l.ing)
            if (!ii) return null
            return (
              <Flex key={i} gap='0.75rem' center width='100%'>
                <BodyText weight='600' style={{ flex: 2 }}>
                  {ii.name}
                </BodyText>
                <Input
                  type='number'
                  width='6rem'
                  value={String(l.qty)}
                  onChange={(e: any) => {
                    const n = [...dish.norm]
                    n[i] = { ...l, qty: Number(e.target.value) }
                    setDish({ ...dish, norm: n })
                  }}
                  nomarg
                />
                <OtherText grey>{ii.recipeUnit}</OtherText>
                <OtherText grey style={{ width: '4rem', textAlign: 'right' }}>
                  ${((l.qty / ii.factor) * ii.price).toFixed(3)}
                </OtherText>
              </Flex>
            )
          })}
        </Flex>
        <Flex gap='0.5rem' center>
          <OtherText grey>Cost per portion (live, batch-weighted):</OtherText>
          <BodyText weight='700' style={{ color: '#ff9900', fontSize: '1rem' }}>
            ${totalCost.toFixed(2)}
          </BodyText>
        </Flex>
        <OtherText grey>
          Saving creates a new normative VERSION effective from tomorrow&apos;s production — historical consumption stays on the version it was cooked under.
        </OtherText>
        <Flex gap='0.5rem' justcenter width='100%'>
          <Button onClick={closeModal}>Cancel</Button>
          <Button orange onClick={() => onSave(dish)}>
            Save as New Version
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}
